import { useNavigate } from 'react-router-dom'

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/card'
import { buildLeadFilterUrl } from '@/shared/lib/leadNavigation'

export default function CampaignPerformanceCard({
  data = [],
  period,
  customRange,
}) {
  const navigate = useNavigate()
  const list = Array.isArray(data) ? data : []

  return (
    <Card className="h-[320px] overflow-hidden">
      <CardHeader className="shrink-0 px-4 pb-0 pt-4 sm:px-5">
        <div className="flex items-start justify-between gap-3">
          <div
            className="cursor-pointer transition hover:opacity-80"
            onClick={() =>
              navigate(
                buildLeadFilterUrl('/marketing/leads', {
                  period,
                  customRange,
                }),
              )
            }
            title="View all campaigns"
          >
            <CardTitle className="text-sm font-semibold text-slate-900">
              Campaign Performance
            </CardTitle>

            <CardDescription className="mt-1 text-[11px] text-slate-400">
              Top campaigns · last 7 days
            </CardDescription>
          </div>

          <span className="shrink-0 rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-semibold text-slate-500">
            7d
          </span>
        </div>
      </CardHeader>

      <CardContent className="min-h-0 overflow-hidden px-4 py-4 sm:px-5">
        <div className="mb-3">
          <span className="text-[10px] font-bold tracking-widest text-slate-400 uppercase">
            Top Campaigns
          </span>
        </div>

        {/* Only this section scrolls */}
        <div className="max-h-[215px] overflow-y-auto divide-y divide-slate-100 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {list.length === 0 ? (
            <p className="py-6 text-center text-xs text-slate-400">
              No campaign activity in the last 7 days.
            </p>
          ) : (
            list.map((campaign) => (
              <div
                key={`${campaign.channel}-${campaign.name}`}
                className="flex cursor-pointer items-center gap-3 py-3 px-2 -mx-2 rounded-lg transition-colors hover:bg-slate-50 first:pt-2 last:pb-2"
                onClick={() => {
                  const source =
                    campaign.channel.toLowerCase() === 'meta'
                      ? 'facebook'
                      : campaign.channel.toLowerCase()
                  navigate(
                    buildLeadFilterUrl('/marketing/leads', {
                      source,
                      period,
                      customRange,
                    }),
                  )
                }}
                title={`View leads for ${campaign.name}`}
              >
                <span
                  className={`min-w-[76px] shrink-0 rounded-full border px-2 py-0.5 text-center text-[10px] font-bold tracking-wide uppercase ${campaign.bgColor} ${campaign.textColor} ${campaign.borderColor}`}
                >
                  {campaign.channel === 'META' ? 'FACEBOOK' : campaign.channel}
                </span>

                <p className="min-w-0 flex-1 truncate text-xs font-medium text-slate-700">
                  {campaign.name.includes('Meta')
                    ? 'Facebook · last 7 days'
                    : campaign.name}
                </p>

                <div className="shrink-0 text-right">
                  <span className="text-sm font-bold text-slate-900">
                    {campaign.leads}
                  </span>

                  <p className="text-[10px] text-slate-400">leads</p>
                </div>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  )
}
